import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Dispatch } from "redux";
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../../reducer/loginSlice';


export default function PortalRejected() {
    const navigate = useNavigate();
    const dispatch: Dispatch = useDispatch();
    const userLoginData = useSelector((state: any) => state.data.login.value);

    const logOut = () => {
        dispatch(login([]));
        navigate('/api-access/login');
    };

    return (
        <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
            <div className="bg-white rounded-[10px] shadow-lg max-w-[500px] w-full p-10 text-center">
                <NavLink to='/'>
                    <img src="/images/Auth/logo.png" alt="hero" className="mx-auto mb-6" />
                </NavLink>

                <div className="bg-red-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#E04343" strokeWidth="2" />
                        <path d="M15 9L9 15M9 9L15 15" stroke="#E04343" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>

                <h1 className="text-[28px] font-[700] text-[#42505C]">Application Not Approved</h1>
                <p className="text-[14px] text-[#404040] mt-3 leading-[24px]">
                    Unfortunately, your API access application for <strong>{userLoginData?.data?.company_name || userLoginData?.name}</strong> was not approved at this time.
                </p>

                {userLoginData?.data?.rejection_reason && (
                    <div className="bg-red-50 border-l-4 border-red-500 rounded-lg p-3 mt-4 text-left">
                        <p className="text-[12px] text-red-800"><strong>Reason:</strong> {userLoginData?.data?.rejection_reason}</p>
                    </div>
                )}

                <p className="text-[13px] text-[#808080] mt-4">
                    If you believe this was a mistake or would like to reapply with updated information,
                    please contact our support team at <span className="text-[#E04343]">api-support@skynet.com</span>
                </p>

                <div className="mt-8 flex flex-col gap-3">
                    <button onClick={logOut} className="text-white bg-[#E04343] rounded-[30px] py-[10px] px-[42px] font-[700] text-[14px] w-full">
                        Sign Out
                    </button>
                    <NavLink to="/" className="text-[#E04343] text-[14px]">Return to Homepage</NavLink>
                </div>
            </div>
        </div>
    );
}